import { filter, includes } from 'lodash/fp';

import { Customer } from '../../../../../selectors/select-customer/types';
import { ProductIdType, ProductType } from '../../../../../types/product';
import constants from '../../../../../ahm-constants';

/**
 * Get product ids for the recommended products on the tax page.
 *
 * @param {object} customer - Object of customer.
 * @param {string} customer.scale - Customer scale ('single', 'couple', 'family' or 'single-parent').
 * @param {object} products - Products object keyed by productId.
 */
const getRecommendedProductIds = ({ scale }: Customer, products: Record<ProductIdType, ProductType>) =>
  filter(
    (productId) => includes(scale, products?.[productId]?.scales?.supported),
    [
      // TODO: AP-1293 Remove ESSENTIALS_BASIC_PLUS_EXCESS_750 and STARTER_BASIC_EXCESS_750 after go live
      // In the meantime ahm-logic is gatekeeping saleable/non-saleable list
      // NOTE: Order doesn't matter; products are sorted by rank in filterHospitalServices function
      constants.PRODUCT.ESSENTIALS_BASIC_PLUS_EXCESS_750,
      constants.PRODUCT.CORE_HOSPITAL_BASIC_PLUS_EXCESS_750,
      constants.PRODUCT.SIMPLE_BRONZE_PLUS_EXCESS_750,
      constants.PRODUCT.STARTER_BASIC_EXCESS_750,
      constants.PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC_EXCESS_750,
      constants.PRODUCT.STARTER_BRONZE_EXCESS_750,
    ],
  );

export default getRecommendedProductIds;
